/* global axios */
import ApiClient from './ApiClient';

class BillingAPI extends ApiClient {
  constructor() {
    // Rutas de billing en este fork: /api/v1/billing/accounts/:account_id/…
    // (ver `rails routes | grep billing`). No usar accountScoped aquí: el
    // ApiClient pondría /api/v1/accounts/:id/billing/… y no coincidiría.
    super('billing', { accountScoped: false });
  }

  get url() {
    const accountId = this.accountIdFromRoute;
    return `${this.apiVersion}/billing/accounts/${accountId}`;
  }

  getUsage() {
    return axios.get(`${this.url}/usage`);
  }

  getInvoices(page = 1, perPage = 20) {
    return axios.get(`${this.url}/invoices?page=${page}&per_page=${perPage}`);
  }

  getPlans() {
    return axios.get(`${this.url}/plans`);
  }

  changePlan(planId, billingCycle = 'monthly') {
    return axios.post(`${this.url}/change_plan`, {
      plan_id: planId,
      billing_cycle: billingCycle,
    });
  }

  cancelSubscription(immediate = false, reason = '') {
    return axios.post(`${this.url}/cancel`, { immediate, reason });
  }

  reactivate() {
    return axios.post(`${this.url}/reactivate`);
  }

  managePayment() {
    return axios.post(`${this.url}/manage_payment`);
  }

  manageBillingInfo() {
    return axios.post(`${this.url}/manage_billing_info`);
  }

  getMacHistory(periodStart, periodEnd, inboxId) {
    let url = `${this.url}/mac_history?`;
    if (periodStart) url += `period_start=${periodStart}&`;
    if (periodEnd) url += `period_end=${periodEnd}&`;
    if (inboxId) url += `inbox_id=${inboxId}`;
    return axios.get(url);
  }

  getLlmUsageHistory(periodStart, periodEnd, feature, model) {
    let url = `${this.url}/llm_usage_history?`;
    if (periodStart) url += `period_start=${periodStart}&`;
    if (periodEnd) url += `period_end=${periodEnd}&`;
    if (feature) url += `feature=${feature}&`;
    if (model) url += `model=${model}`;
    return axios.get(url);
  }

  syncInvoices() {
    return axios.post(`${this.url}/sync_invoices`);
  }

  purchaseAddOn(productId, quantity) {
    return axios.post(`${this.url}/purchase_add_on`, {
      product_id: productId,
      quantity,
    });
  }

  getAddOns() {
    return axios.get(`${this.url}/add_ons`);
  }

  getAddOnProducts() {
    return axios.get(`${this.url}/add_on_products`);
  }

  cancelAddOn(addOnId) {
    return axios.post(`${this.url}/cancel_add_on`, { add_on_id: addOnId });
  }
}

export default new BillingAPI();
